export const CITIES_LIST = [
  {
    name: `Санкт-Петербург`,
    type: `город`
  },
  {
    name: `Гатчина`,
    type: `город`
  },
  {
    name: `Мурино`,
    type: `город`
  },
  {
    name: `Всеволожск`,
    type: `город`
  },
  {
    name: `Выборг`,
    type: `город`
  },
  {
    name: `Сосновый Бор`,
    type: `город`
  },
  {
    name: `Сертолово`,
    type: `город`
  },
  {
    name: `Тихвин`,
    type: `город`
  },
  {
    name: `Кириши`,
    type: `город`
  },
  {
    name: `Кудрово`,
    type: `город`
  },
  {
    name: `Кингисепп`,
    type: `город`
  },
  {
    name: `Волхов`,
    type: `город`
  },
  {
    name: `Тосно`,
    type: `город`
  },
  {
    name: `Луга`,
    type: `город`
  },
  {
    name: `Сланцы`,
    type: `город`
  },
  {
    name: `Кировск`,
    type: `город`
  },
  {
    name: `Отрадное`,
    type: `город`
  },
  {
    name: `Никольское`,
    type: `город`
  },
  {
    name: `Коммунар`,
    type: `город`
  },
  {
    name: `Пикалёво`,
    type: `город`
  },
  {
    name: `Лодейное Поле`,
    type: `город`
  },
  {
    name: `Приозерск`,
    type: `город`
  },
  {
    name: `Подпорожье`,
    type: `город`
  },
  {
    name: `Светогорск`,
    type: `город`
  },
  {
    name: `Бокситогорск`,
    type: `город`
  },
  {
    name: `Шлиссельбург`,
    type: `город`
  },
  {
    name: `Сясьстрой`,
    type: `город`
  },
  {
    name: `Волосово`,
    type: `город`
  },
  {
    name: `Ивангород`,
    type: `город`
  },
  {
    name: `Новая Ладога`,
    type: `город`
  },
  {
    name: `Каменногорск`,
    type: `город`
  },
  {
    name: `Приморск`,
    type: `город`
  },
  {
    name: `Любань`,
    type: `город`
  },
  {
    name: `Высоцк`,
    type: `город`
  },
  {
    name: `Рощино`,
    type: `посёлок`
  },
  {
    name: `Янино-1`,
    type: `посёлок`
  },
  {
    name: `Ульяновка`,
    type: `посёлок`
  },
  {
    name: ``,
    type: `посёлок`
  },
  {
    name: `имени Свердлова`,
    type: `посёлок`
  },
  {
    name: `Сиверский`,
    type: `посёлок`
  },
  {
    name: `Вырица`,
    type: `посёлок`
  },
  {
    name: `Кузьмоловский`,
    type: `посёлок`
  },
  {
    name: `имени Морозова`,
    type: `посёлок`
  },
  {
    name: `Мга`,
    type: `посёлок`
  },
  {
    name: `Дубровка`,
    type: `посёлок`
  },
  {
    name: `Советский`,
    type: `посёлок`
  },
  {
    name: `Форносово`,
    type: `посёлок`
  },
  {
    name: `Новоселье`,
    type: `посёлок`
  },
  {
    name: `Приладожский`,
    type: `посёлок`
  },
  {
    name: `Токсово`,
    type: `посёлок`
  },
  {
    name: `Красный Бор`,
    type: `посёлок`
  },
  {
    name: `Виллози`,
    type: `посёлок`
  },
  {
    name: `Назия`,
    type: `посёлок`
  },
  {
    name: `Лебяжье`,
    type: `посёлок`
  },
  {
    name: `Синявино`,
    type: `посёлок`
  },
  {
    name: `Кузнечное`,
    type: `посёлок`
  },
  {
    name: `Фёдоровское`,
    type: `посёлок`
  },
  {
    name: `Рахья`,
    type: `посёлок`
  },
  {
    name: `Будогощь`,
    type: `посёлок`
  },
  {
    name: `Дружная Горка`,
    type: `посёлок`
  },
  {
    name: `Павлово`,
    type: `посёлок`
  },
  {
    name: `Ефимовский`,
    type: `посёлок`
  },
  {
    name: `Лесогорский`,
    type: `посёлок`
  },
  {
    name: `Рябово`,
    type: `посёлок`
  },
  {
    name: `Тайцы`,
    type: `посёлок`
  },
  {
    name: `Большая Ижора`,
    type: `посёлок`
  },
  {
    name: `Толмачёво`,
    type: `посёлок`
  },
  {
    name: `Никольский`,
    type: `посёлок`
  },
  {
    name: `Важины`,
    type: `посёлок`
  },
  {
    name: `Вознесенье`,
    type: `посёлок`
  },
  {
    name: `Свирьстрой`,
    type: `посёлок`
  },
];
